import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-side-navigation-submenu-service',
  templateUrl: './side-navigation-submenu-service.component.html',
  styleUrls: ['./side-navigation-submenu-service.component.scss']
})
export class SideNavigationSubmenuServiceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
